import styled from "styled-components";
import CapaResumo from '../../../../../../../../../../assets/img/fertilitdade/CapaResumo.5b42acd4.webp';


export const Capa_resumo = styled.div`
    position: relative;
    background-image: url(${CapaResumo});
    background-size: cover;
    position: relative;
    overflow: hidden;
    display: flex;
    width: 210mm;
    height: 297mm;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-left: 210px;
    border: 1px solid #e0e0e0;

    div.Capa__responsavel {
        position: absolute;
        right: 50px;
        bottom: 340px;
        text-align: right;

        h2.Capa__responsavel__nome {
            font-size: 20px;
            font-weight: 600;
            color: #00a8b9;
            margin: 0;
        }
        span.Capa__responsavel__formacao {
            color: var(--text-color-light);
            font-weight: 600;
            margin-top: 3px;
            font-size: 14px;
        }
    }

    img {
        height: 75px;
        position: absolute;
        right: 50px;
        bottom: 30px;
    }
`;